<template>
  <section>
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon>Registro de Patrocinios
    </h3>
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Patrocinio</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="dialog2" max-width="900px" persistent>
          <v-card class="elevation-2">
            <v-timeline align-top>
              <v-timeline-item
                v-for="(item, i) in tramites"
                :color="item.color"
                :icon="item.icon"
                :key="i"
                fill-dot
              >
                <v-card :color="item.color" dark>
                  <v-card-title class="title">{{item.etapa}}</v-card-title>
                  <v-card-text class="white text--primary">
                    <p>{{item.proveido}}</p>
                    <p>{{item.fecha | formatDate}}</p>
                    <p>{{item['res_tramite.persona.nombre_completo']}}</p>
                    <v-btn :color="item.color" class="mx-0" outline>Button</v-btn>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close2">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>
        <!-- Dialogo para completar el registro de patrocinios-->
        <v-dialog v-model="dialogComPatrocinio" max-width="900px" persistent>
          <v-card color="grey lighten-3">
            <v-card-title class="headline grey lighten-2" primary-title>Completar patrocinio</v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-subheader>CI Solicitante:</v-subheader>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.ci}}</p>
                    </v-card-text>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-subheader>Nombre Solicitante:</v-subheader>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.solicitante}}</p>
                    </v-card-text>
                  </v-flex>

                  <!-- Data iterator para los usuarios -->
                  <v-btn color="primary" value="Invitado" @click.native.stop="crearObj()">
                    <v-icon dark>person_add</v-icon>&nbsp; Demandado
                  </v-btn>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-data-iterator
                        :items="demandados"
                        content-tag="v-layout"
                        row
                        wrap
                        hide-actions
                        hide-headers
                      >
                        <v-flex slot="item" slot-scope="props" xs12>
                          <v-card v-model="card">
                            <v-card-text>
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-icon
                                    @click="deleteItem(props.item)"
                                    class="mr-2"
                                    color="red accent-4"
                                  >close</v-icon>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field label="CI" v-model="props.item.nro_documento"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field label="Nombre" v-model="props.item.nombres"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field
                                      label="Primer apellido"
                                      v-model="props.item.primer_apellido"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field
                                      label="Segundo apellido"
                                      v-model="props.item.segundo_apellido"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field label="Telefono" v-model="props.item.telefono"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md6>
                                    <v-text-field label="Dirección" v-model="props.item.direccion"></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-data-iterator>
                    </v-layout>
                  </v-container>
                  <!-- Fin del data iterator -->
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_materia"
                      :items="materia"
                      item-text="valor"
                      item-value="clave"
                      label="Materia"
                      persistent-hint
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <!-- <v-select
                      v-model="select_delito"
                      :items="delito"
                      item-text="valor"
                      item-value="clave"
                      label="Delito"
                      persistent-hint
                      return-object
                    ></v-select>-->
                    <v-combobox
                      v-model="select_delito"
                      :items="delito"
                      label="Proceso / Delito"
                      item-text="valor"
                      item-value="clave"
                      persistent-hint
                      return-object
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="nurej" label="IANUS/NUREJ" maxlength="50"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="juzgado" label="Juzgado:" maxlength="80"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="closeComPatrocinio">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="savePatrocinio">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIn dialogo completar patrocinio -->
        <!-- LLenar detalle -->
        <v-dialog v-model="dialogActuacion" max-width="700px" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-3" primary-title>Añadir actuación</v-card-title>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-subheader>CI Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.ci}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-subheader>Nombre Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.solicitante}}</p>
                  </v-card-text>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-subheader>Materia:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.materia}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-subheader>Proceso:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.delito}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm4>
                  <v-select
                    v-model="select_etapa_patrocinio"
                    :items="etapa_patrocinio"
                    item-text="valor"
                    item-value="clave"
                    label="Etapa"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    v-model="select_actuacion"
                    :items="actuacion"
                    item-text="valor"
                    item-value="clave"
                    label="Actuación"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="date"
                      label="Fecha Actuación"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" @input="menu2 = false" locale="es-419"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="observacion"
                    auto-grow
                    box
                    color="blue"
                    label="Observación"
                    rows="3"
                    counter="100"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="closeActuacion">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="saveActuacion">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Fin de llenar detalle   -->
        <!-- DIALOG ENVIO -->
        <v-dialog v-model="dialogEnviar" max-width="700px" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-3" primary-title>Envío deL Patrocinio</v-card-title>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-subheader>CI Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.ci}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-subheader>Nombre Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.solicitante}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-select
                    v-model="select_etapa"
                    :items="flujoDestino"
                    item-text="flujo_destino"
                    item-value="flujoDestino"
                    label="Enviar a"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="select_abogado"
                    :items="abogado"
                    item-text="nombre"
                    item-value="id"
                    label="Abogado"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="proveido"
                    auto-grow
                    box
                    color="blue"
                    label="Proveído"
                    rows="3"
                    counter="300"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="closeEnviar">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="saveEnvio">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <!-- lista patrocinios -->
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :pagination.sync="pagination"
        :total-items="pagination.totalItems"
        rowsPerPageText="Filas por página"
        noResultsText="No se encontraron registros que coincidan"
        noDataText="No hay resultados"
        :rowsPerPageItems="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="justify-center layout px-0">
              <v-tooltip bottom>
                <v-icon
                  slot="activator"
                  v-if="props.item.estado === 'ACTIVO'"
                  color="light-green darken-2"
                  @click="completarPatrocinio(props.item)"
                >assignment</v-icon>
                <span>Completar patrocinio</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-icon
                  slot="activator"
                  color="light-green darken-4"
                  class="mr-2"
                  @click="flowItem(props.item)"
                >call_split</v-icon>
                <span>Ver flujo del caso</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-icon
                  v-if="props.item.estado === 'ACTIVO'"
                  slot="activator"
                  class="mr-2"
                  color="light-blue darken-2"
                  @click="agregarActuacion(props.item)"
                >add_circle</v-icon>
                <span>Agregar actuación</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-icon
                  v-if="props.item.estado === 'ACTIVO'"
                  slot="activator"
                  class="mr-2"
                  @click="enviarItem(props.item)"
                  flat
                  color="cyan lighten-2"
                >send</v-icon>
                <span>Enviar Caso</span>
              </v-tooltip>
            </td>
            <td>{{ props.item.codigo }}</td>
            <td class="text-xs-right">{{ props.item.ci }}</td>
            <td class="text-xs-right">{{ props.item.solicitante }}</td>
            <td class="text-xs-right">{{ props.item.enviado_por }}</td>
            <td class="text-xs-right">{{ props.item.fecha | formatDate }}</td>
            <td class="text-xs-right">{{ props.item.estado }}</td>
            <td class="text-xs-right" v-if="$util.isRol('DIRECTOR')">{{ props.item.centro }}</td>
            <td class="text-xs-right" v-if="$util.isRol('DIRECTOR')">{{ props.item.abogado }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <!-- <v-card flat>
            <v-card-text>Actuaciones</v-card-text>
          </v-card>-->
          <v-data-table
            :headers="headersActuaciones"
            :items="props.item.actuaciones"
            class="elevation-1"
            hide-actions
            dark
            no-data-text="No se tienen actuaciones registradas para este caso"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.p_actuacion}}</td>
              <td class="text-xs-right">{{ props.item.fecha_actuacion | formatDate }}</td>
              <td class="text-xs-right">{{ props.item.descripcion }}</td>
            </template>
          </v-data-table>
        </template>
        <template
              slot="pageText"
              slot-scope="{ pageStart, pageStop }"
            >{{ pageStart }}-{{ pageStop }} de {{ pagination.totalItems }}</template>
        <!-- <v-alert
          slot="no-results"
          :value="true"
          color="info"
          icon="warning"
        >Tu búsqueda para "{{ search }}" no obtuvo resultados</v-alert> -->
      </v-data-table>
    </div>
  </section>
</template>
<script>
import moment from 'moment';
export default {
  data: () => ({
    rowsPerPageItems: [5, 10, 20],
    pagination: {
      rowsPerPage: 5,
      page: 1
    },
    dialog: false,
    dialog2: false,
    dialogVisor: false,
    dialogEnviar: false,
    dialogComPatrocinio: false,
    dialogActuacion: false,
    filaActual: {},
    flujoDestino: [],
    select_idioma: { valor: 'Castellano', clave: 'CASTELLANO' },
    select_estado_civil: { valor: 'Soltero (a)', clave: 'SOLTERO' },
    select_genero: { valor: 'Femenino', clave: 'FEMENINO' },
    select_departamento: { nombre: 'La Paz', codigo: '02' },
    select_abogado: { nombre: 'Abogado', id: 0 },
    select_etapa: { valor: 'Conciliación', clave: 'CONCILIACION' },
    select_materia: { valor: 'MAT', clave: 'MAT' },
    select_delito: { valor: '', clave: '' },
    select_etapa_patrocinio: { valor: 'etapa', clave: 'etapa' },
    select_actuacion: { valor: 'actuacion', clave: 'actuacion' },
    idioma: [],
    tramites: [],
    estado_civil: [],
    genero: [],
    departamento: [],
    abogado: [],
    materia: [],
    delito: [],
    proveido: '',
    observacion: '',
    datosDemandado: {},
    etapa_patrocinio: [],
    actuacion: [],
    search: '',
    date: new Date().toISOString().substr(0, 10),
    menu2: false,
    demandados: [],
    headers: [],
    nurej: null,
    juzgado: null,
    // headers: [
    //   { text: 'Opciones', value: 'name', sortable: false },

    //   {
    //     text: 'Código',
    //     align: 'left',
    //     sortable: false,
    //     value: 'codigo'
    //   },
    //   { text: 'C. I.', value: 'ci' },
    //   { text: 'Solicitante', value: 'nombres' },
    //   { text: 'Enviado por', value: 'apellidos' },
    //   { text: 'Fecha de asignación', value: 'apellidos' },
    //   { text: 'Estado', value: 'estado' }
    // ],
    headersActuaciones: [
      {
        text: 'Tipo actuación',
        align: 'left',
        sortable: false,
        value: 'actuacion'
      },
      { text: 'Fecha Actuacion', value: 'fecha_actuacion' },
      { text: 'Descripción', value: 'descripcion' }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Datos del Solicitante' : 'Orientación ';
    },
    pages () {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 1;
      }
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  filters: {
    formatDate: function (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm');
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    },
    select_materia (val) {
      let mat = 'PENAL';
      if (val.valor === 'CIVIL') {
        mat = 'CIVIL';
      }
      if (val.valor === 'FAMILIAR') {
        mat = 'FAMILIAR';
      }
      if (val.valor === 'PENAL') {
        mat = 'PENAL';
      }
      if (val.valor === 'AGRARIO') {
        mat = 'AGRARIO';
      }
      if (val.valor === 'ADMINISTRATIVO') {
        mat = 'ADMINISTRATIVO';
      }
      if (val.valor === 'NUEVOS_TIPOS_PENAL') {
        mat = 'NUEVOS_TIPOS_PENAL';
      }
      if (val.valor === 'LABORAL') {
        mat = 'LABORAL';
      }

      this.$service['get'](`v1/parametricas?grupo=${mat}`).then(response => {
        if (response) {
          this.delito = response;
        }
      });
    },
    select_etapa (val) {
      let prof = 'ABOGADO';
      if (val.flujo_destino === 'PSICOLOGIA') {
        prof = 'PSICOLOGO';
      }
      if (val.flujo_destino === 'TRABAJO_SOCIAL') {
        prof = 'TRABAJADOR_SOCIAL';
      }
      this.$service['get'](`v1/centros/usuarios?tipo=${prof}`).then(
        response => {
          if (response) {
            this.abogado = response;
          }
        }
      );
    },
    pagination: function () {
      this.listar();
    },
    search: function (filter) {
      this.listar(filter);
    }
  },

  created () {
    this.initialize();
    if (this.$util.isRol('DIRECTOR')) {
      this.headers = [
        { text: 'Opciones', value: 'name', sortable: false },

        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'codigo'
        },
        { text: 'C. I.', value: 'ci' },
        { text: 'Solicitante', value: 'nombres' },
        { text: 'Enviado por', value: 'apellidos' },
        { text: 'Fecha de asignación', value: 'apellidos' },
        { text: 'Estado', value: 'estado' },
        { text: 'Centro', value: 'centro' },
        { text: 'Abogado', value: 'abogado' }
      ];
    } else {
      this.headers = [
        { text: 'Opciones', value: 'name', sortable: false },

        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'codigo'
        },
        { text: 'C. I.', value: 'ci' },
        { text: 'Solicitante', value: 'nombres' },
        { text: 'Enviado por', value: 'apellidos' },
        { text: 'Fecha de asignación', value: 'apellidos' },
        { text: 'Estado', value: 'estado' }
      ];
    }
  },

  methods: {
    initialize () {
      this.listar();
      this.$service['get']('v1/parametricas?grupo=IDIOMA').then(response => {
        if (response) {
          this.idioma = response;
        }
      });
      this.$service['get']('v1/parametricas?grupo=ESTADO_CIVIL').then(
        response => {
          if (response) {
            this.estado_civil = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=GENERO').then(response => {
        if (response) {
          this.genero = response;
        }
      });
      this.$service['get']('v1/dpas/departamentos').then(response => {
        if (response) {
          this.departamento = response;
          // console.log('response',response);
        }
      });
      this.$service['get']('v1/parametricas?grupo=TRAMITE_ETAPA').then(
        response => {
          if (response) {
            this.tramite = response;
          }
        }
      );
    },
    listar (filter = '') {
      const { page, rowsPerPage } = this.pagination;
      this.$service['get'](`v1/patrocinios?page=${page}&limit=${rowsPerPage}&q=${filter}`).then(response => {
        this.desserts = [];
        if (response) {
          this.pagination.totalItems = response.count;
          for (let item of response.rows) {
            this.desserts.push({
              ci: item.persona_solicitante.nro_documento,
              nombres: item.persona_solicitante.nombres,
              apellidos: `${item.persona_solicitante.primer_apellido ||
                ''} ${item.persona_solicitante.segundo_apellido || ''}`,
              solicitante: `${item.persona_solicitante.nombres} ${item
                .persona_solicitante.primer_apellido || ''} ${item
                .persona_solicitante.segundo_apellido || ''}`,
              abogado: `${item.persona_responsable.nombres} ${item
                .persona_responsable.primer_apellido || ''}`,
              enviado_por: `${item.persona_envio.nombres} ${item.persona_envio
                .primer_apellido || ''}`,
              demandados: item.demandados,
              fecha: item.fecha_creacion,
              codigo: item.codigo,
              id: item.id,
              flujo: item.flujo,
              flujo_actual_key: item.flujo_actual_key,
              solicitud_id: item.solicitud_id,
              estado: item.estado,
              materia: item.materia,
              delito: item.delito,
              actuaciones: item.actuaciones,
              centro: item.centro,
              nurej: item.nurej,
              juzgado: item.juzgado
            });
          }
        }
      });
    },
    completarPatrocinio (item) {
      this.filaActual = item;
      this.$service['get']('v1/parametricas?grupo=PATROCINIO_MATERIA').then(
        response => {
          if (response) {
            this.materia = response;
          }
        }
      );
      this.select_materia = item.materia;
      this.select_delito = item.delito;
      this.nurej = item.nurej;
      this.juzgado = item.juzgado;
      this.demandados = item.demandados ? item.demandados : [];
      // this.demandados = item.demandados;
      this.dialogComPatrocinio = true;
    },
    agregarActuacion (item) {
      this.filaActual = item;
      this.$service['get']('v1/parametricas?grupo=PATROCINIO_ETAPA').then(
        response => {
          if (response) {
            this.etapa_patrocinio = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=PATROCINIO_ACTUACION').then(
        response => {
          if (response) {
            this.actuacion = response;
          }
        }
      );
      this.dialogActuacion = true;
    },
    flowItem (item) {
      this.$service['get'](`v1/solicitudes/${item.solicitud_id}/tramites`).then(
        response => {
          this.tramites = response;
          this.dialog2 = true;
        }
      );
    },
    visorItem (item) {
      this.filaActual = item;
      this.dialogVisor = true;
    },
    enviarItem (item) {
      this.filaActual = item;
      this.flujoDestino = item.flujo;
      this.dialogEnviar = true;
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.nurej = item.nurej;
      this.juzgado = item.juzgado;
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.demandados.indexOf(item);
      confirm('¿Está seguro de borrar al demandado?') &&
        this.demandados.splice(index, 1);
    },
    close () {
      this.limpiarFormulario();
      this.dialog = false;
    },
    close2 () {
      this.dialog2 = false;
    },
    closeVisor () {
      this.dialogVisor = false;
    },
    closeComPatrocinio () {
      this.datosDemandado = [];
      this.select_materia = [];
      this.select_delito = [];
      this.dialogComPatrocinio = false;
    },
    closeActuacion () {
      this.select_etapa_patrocinio = [];
      this.select_actuacion = [];
      this.observacion = '';
      this.dialogActuacion = false;
    },
    limpiarFormulario () {
      this.select_idioma = { valor: 'Castellano', clave: 'CASTELLANO' };
      this.select_estado_civil = { valor: 'Soltero (a)', clave: 'SOLTERO' };
      this.select_genero = { valor: 'Femenino', clave: 'FEMENINO' };
      this.select_departamento = { nombre: 'La Paz', clave: '02' };
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.select_abogado = { nombre: 'Abogado', id: 0 };
    },

    saveOrientacion () {
      let data = {
        motivo: this.editedItem.motivo,
        conclusion: this.editedItem.conclusion
      };
      this.$service['patch'](
        `v1/orientaciones/${this.editedItem.id}`,
        data
      ).then(response => {
        // const a = {
        //   motivo: this.editItem.motivo,
        //   conclusion: this.editItem.conclusion
        // };
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        this.close();
      });
    },
    saveEnvio () {
      let data = {
        flujo_actual_key: this.filaActual.flujo_actual_key,
        flujo_actual_id: this.filaActual.id,
        flujo_destino: this.select_etapa.flujo_destino,
        flujo_destino_key: this.select_etapa.flujo_destino_key,
        proveido: this.proveido,
        responsable_id: this.select_abogado.id
      };
      this.$service['patch']('v1/casos', data).then(response => {
        this.listar();
        this.dialogEnviar = false;
      });
    },
    closeEnviar () {
      this.dialogEnviar = false;
    },
    generarflujo () {
      this.$service['get'](
        `v1/solicitudes/${this.filaActual.solicitud_id}/tramites`
      ).then(response => {
        this.dialog2 = true;
      });
    },
    savePatrocinio () {
      let dataDetalle = {
        demandados: this.demandados,
        materia: this.select_materia.clave,
        delito: this.select_delito.clave,
        nurej: this.nurej,
        juzgado: this.juzgado
      };
      this.$service['patch'](
        `v1/patrocinios/${this.filaActual.id}`,
        dataDetalle
      ).then(response => {
        // this.filaActual.etapa = etapa;
        this.demandados = [];
        this.select_materia = [];
        this.select_delito = [];
        this.dialogComPatrocinio = false;
      });
    },
    saveActuacion () {
      let dataDetalle = {
        demandados: this.demandados,
        etapa: this.select_etapa_patrocinio.clave,
        actuacion: this.select_actuacion.clave,
        fecha_actuacion: this.date,
        descripcion: this.observacion,
        patrocinio_id: this.filaActual.id
      };
      this.$service['post'](
        `v1/patrocinios/${this.filaActual.id}/actuaciones`,
        dataDetalle
      ).then(response => {
        // this.filaActual.etapa = etapa;
        this.select_etapa_patrocinio = [];
        this.select_actuacion = [];
        this.observacion = '';
        // this.actuaciones = response;
        this.listar();
        // fin de actualizando el listado
        this.dialogActuacion = false;
      });
    },
    crearObj () {
      this.demandados.push({
        nro_documento: '',
        nombres: '',
        primer_apellido: '',
        segundo_apellido: '',
        telefono: ''
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/casos/patrocinios/Patrocinio.vue